/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CrmType} from '../models/CrmType';
import type {Error} from '../models/Error';
import type {GetCrmLimit} from '../models/GetCrmLimit';
import type {SaveCrmLimit} from '../models/SaveCrmLimit';

export interface GetCrmLimits$Request {
    licenseId: number;
    crmType: CrmType;
    accountId: number;
}

export interface GetCrmLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCrmLimitsRequest = createAction<PayloadData<void, GetCrmLimits$Request>>('CRM_LIMITS_CONTROLLER__GET_CRM_LIMITS__REQUEST');
export const getCrmLimitsSuccess = createAction<PayloadData<GetCrmLimit, GetCrmLimits$Request>>('CRM_LIMITS_CONTROLLER__GET_CRM_LIMITS__SUCCESS');
export const getCrmLimitsFailure = createAction<PayloadData<Error, GetCrmLimits$Request, true>>('CRM_LIMITS_CONTROLLER__GET_CRM_LIMITS__FAILURE');

export const getCrmLimitsActions = [
    getCrmLimitsRequest,
    getCrmLimitsSuccess,
    getCrmLimitsFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {CrmType} meta.crmType
 * @param {number} meta.accountId Account ID
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCrmLimits = (meta: GetCrmLimits$Request, config?: GetCrmLimits$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: getCrmLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.licenseId}/limits/${meta.crmType}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveCrmLimits$Request {
    licenseId: number;
    crmType: CrmType;
    saveCrmLimit: SaveCrmLimit;
}

export interface SaveCrmLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveCrmLimitsRequest = createAction<PayloadData<void, SaveCrmLimits$Request>>('CRM_LIMITS_CONTROLLER__SAVE_CRM_LIMITS__REQUEST');
export const saveCrmLimitsSuccess = createAction<PayloadData<void, SaveCrmLimits$Request>>('CRM_LIMITS_CONTROLLER__SAVE_CRM_LIMITS__SUCCESS');
export const saveCrmLimitsFailure = createAction<PayloadData<Error, SaveCrmLimits$Request, true>>('CRM_LIMITS_CONTROLLER__SAVE_CRM_LIMITS__FAILURE');

export const saveCrmLimitsActions = [
    saveCrmLimitsRequest,
    saveCrmLimitsSuccess,
    saveCrmLimitsFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {CrmType} meta.crmType
 * @param {SaveCrmLimit} meta.saveCrmLimit
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveCrmLimits = (meta: SaveCrmLimits$Request, config?: SaveCrmLimits$Config) => {
    return {
        CALL_API: {
            types: saveCrmLimitsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.licenseId}/limits/${meta.crmType}`,
            TRANSPORT_REQUEST_BODY: meta.saveCrmLimit,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

